// EmailVerify.js
import React, { useState, useEffect } from "react";
import "@Styles/mandate.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { applyReferralCode, registerUser,sendBasicDetails } from "../../../../Redux/Authenticate/action";
import "@Styles/mandate.css";
import { HEADING_MAIL } from "../../Common/constant";
import ToastMsg from "../../../../helper/ToastMsg";
import { getUserDetail } from "../../../../Redux/GeneralDetails/action";
import { getDocumentStatus } from "../../../../Redux/Manual_Kyc_Details/action";
import { withRouter } from "../../../../hooks/withRouter";
import { trackRegistrationPageView, trackCompleteRegistration } from "../../../../utils/metaPixel";
import NewUserEmail from "./NewUserEmail";
import VerifyOtpemail from "./VerifyOtpemail"; // popup
import { initializeApp } from "firebase/app";
import { Helmet } from "react-helmet";
import orGmail from "../../../../Images/orgmail.png";
import { GoogleLogin } from "@react-oauth/google";
import { GoogleOAuthProvider } from "@react-oauth/google";


const EmailVerify = (props) => {
  const navigate = useNavigate();
  const emailUrl = process.env.REACT_APP_MMB_EMAIL;
  const referrer = localStorage.getItem("referrer");
  const isOpenfrom = localStorage.getItem("isOpenFrom");
  const token = props?.user?.token || localStorage.getItem("gpay_token");
  const phone_number =
    props?.user?.phone_number || localStorage.getItem("phone_number");

  const [state, setState] = useState({
    displaySignInModal: true,
    isLoading: false,
  });

  let [error, seterror] = useState(null);
  let [loader, setloader] = useState(false);
  const [acceptTandC, setacceptTandC] = useState(false);
  const [Error, setError] = useState(null);
  const [gmailvisible, setGmailvisible] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(
    window.innerWidth > 440
  );

  // popup state for email OTP
  const [showEmailOtpModal, setShowEmailOtpModal] = useState(false);
  const [otpEmail, setOtpEmail] = useState(null);
  const [otpPhone, setOtpPhone] = useState(phone_number);


useEffect(() => {
  trackRegistrationPageView();
  {isOpenfrom =="true" && setGmailvisible(true)}
  const handleResize = () => {
    setIsLargeScreen(window.innerWidth > 440);
  };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const acceptTermsAndCond = (props) => {
    setError(null);
    setacceptTandC(!acceptTandC);
  };

  const openEmailOtpPopup = (email, phone) => {
    setOtpEmail(email);
    setOtpPhone(phone || phone_number || localStorage.getItem("phone_number"));
    setShowEmailOtpModal(true);
  };

  const responseGoogle = (response) => {
    console.log("im inside response google", response);

    const receivedKey = localStorage.getItem("receivedKey");

    let data = {
      type: "google",
      access_token: response,
      phone_number: Number(localStorage.getItem("phone_number")),
    };
    props
      .registerUser(data)
      .then((res) => {
        if (referrer !== null && referrer !== undefined && referrer.trim() !== "") {
          saveReferral(res?.data?.data?.token, referrer);
        }
const token_ = res?.data?.data?.token;
        trackCompleteRegistration({
          phone_number: localStorage.getItem("phone_number"),
          registration_type: "google",
          user_id: res?.data?.data?.id,
        });
        props
          .getUserDetail(token_)
          .then((res) => {
              // Send AppsFlyer ID to backend after OTP verification      
                        props.sendBasicDetails(token_,res?.data?.data?.id)
                          .catch(err => {
                            console.error('Failed to send AppsFlyer ID:', err);
                          });
            let nv_data = res?.data?.data?.customusermodel;

            let user_data_nv = {
              mobile: nv_data?.phone_number,
              email: res?.data?.data?.email,
              name: nv_data?.first_name + " " + nv_data?.last_name,
              "preferred language": "en",
              registrationStartDate: res.data.data.created_at,
            };

            let user_data = {
              mobile: `91${nv_data.phone_number}`,
              gender: nv_data?.gender,
              birth_date: nv_data?.date_of_birth,
              "preferred language": "en",
              registrationStartDate: res.data.data.created_at,
              email: res?.data?.data?.email,
              name: nv_data?.first_name + " " + nv_data?.last_name,
            };

            let result_nv = nv_data?.gender ? user_data : user_data_nv;

          })
          .catch((err) => {
            if (err?.response?.status === 401) {
              window.location.href = "/";
              localStorage.removeItem("gpay_token");
            }
          });

        props
          .getDocumentStatus(res?.data?.data?.token)
          .then((res) => {
            const receivedKey = localStorage.getItem("receivedKey");
            res.data.map((details) => {
              if (details.karza === true) {
                navigate("/karza");
              } else {
                navigate("/creditlimit");
                // receivedKey
                //   ? navigate("/creditlimit")
                //   : navigate("/dashboard_s");
              }
            });
          })
          .catch((err) => {
            setState({ loader: false });
            if (err.response?.status === 401) {
              window.location.href = "/";
              localStorage.removeItem("gpay_token");
            }
            let error = err?.response?.data?.error;
            ToastMsg(error, "error");
          });
      })
      .catch((err) => {
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        if (err.response?.status === 401) {
          navigate("/");
        }
        setloader(false);
      });
  };

  const saveReferral = (token,referCode) => {
    const clickid = localStorage.getItem("clickid");
    const storedPartnerId = localStorage.getItem("partner_id");
    props
      .applyReferralCode(token, referCode, clickid, storedPartnerId || null)
      .then((res) => {
      console.log("res", res);
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
      });
  };

  const notagmailpopup = () => {
    setGmailvisible(true);
  };

  const responseGoogleFail = () => {
    setloader(false);
    setError("Unable to Sign up, please try again");
  };

  return (
    <GoogleOAuthProvider clientId="129233907287-limv904v69245fpdntscqfo89br1ijif.apps.googleusercontent.com">
      <>
        <Helmet>
          <script>
            {`gtag('event', 'conversion', {'send_to': 'AW-16911879713/f27dCIzUsssaEKGcm4A_'});`}
          </script>
        </Helmet>
        <div id="background" className="main_div">
          <div className="">
            {isLargeScreen && (
              <div className="shadowline sticky-header  paddingLeftRight">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    padding: "23px 0px 20px",
                  }}
                >
                  <h1
                    className="boldheading"
                    style={{
                      paddingLeft: "27px",
                      color: "#152745",
                      fontWeight: "700",
                      fontSize: "25px",
                    }}
                  >
                    {HEADING_MAIL}
                  </h1>
                </div>
              </div>
            )}
            <div className="toolbarRespo">
              {!isLargeScreen && (
                <div className="shadowline sticky-header maxWidth450 paddingLeftRight">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      padding: "23px 0px 20px",
                    }}
                  >
                    <h1
                      className="boldheading"
                      style={{
                        paddingLeft: "27px",
                        color: "#152745",
                        fontWeight: "700",
                        fontSize: "25px",
                      }}
                    >
                      {HEADING_MAIL}
                    </h1>
                  </div>
                </div>
              )}

              <div className="topmargincontainer wrapper-content container">
                <div className="card-heightnew px-4  pt-1 w-100 text-center mx-auto rounded-40 ">
                  <div className="h-100 d-flex flex-column justify-content-between">
                    <div className="pt-4 ">
                      <img
                        src={emailUrl}
                        alt="frame"
                        className="roundastroemail "
                      />

                      <div className="marzinfix">
                      {isOpenfrom != "true" && (
  <div className="google-login-wrapper">
    <GoogleLogin
      onSuccess={(credentialResponse) => {
        responseGoogle(credentialResponse.credential);
      }}
      onError={() => {
        console.log("Login Failed");
      }}
      width="280"              // 🔹 Controls the button width
      theme="outline"          // (optional) keeps default look
      size="large"             // (optional) nice readable size
      text="continue_with"     // (optional) tweak label
      shape="rectangular"      // (optional) clean shape
      logo_alignment="left"    // (optional) icon on left, text after
    />
  </div>
)}




                        {isOpenfrom != "true" && (
                          <img
                            className="mb-30 mt-30"
                            src={orGmail}
                            width={"264px"}
                          />
                        )}
                        {/* <br /> */}
                        {!gmailvisible && (
                          <a
                            onClick={notagmailpopup}
                            className="mmb-gradient-underline "
                          >
                            Not a Gmail User?
                          </a>
                        )}

                        {gmailvisible && (
                          <NewUserEmail
                            // call this after emailVerify success
                            onOtpSent={openEmailOtpPopup}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <VerifyOtpemail
                isOpen={showEmailOtpModal}
                onRequestClose={() => setShowEmailOtpModal(false)}
                email={otpEmail}
                phone_number={otpPhone}
              />
            </div>
          </div>
        </div>
      </>
    </GoogleOAuthProvider>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
export default withRouter(connect(mapStateToProps, {
  EmailVerify,
  registerUser,
  getUserDetail,
  getDocumentStatus,
  applyReferralCode,
  sendBasicDetails,
})(EmailVerify));
